export const ROUTES = Object.freeze({
    any: '*',
    default: '/',
    todos: '/tasks',
    account: '/account',
    login: '/login',
    signup: '/signup',
    forgotpassword: '/forgotpassword',
    code: '/code',
    test: '/test',
});